import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import ArrowRight from "@/assets/icons/misc/arrow-right.tsx"
import NewPlusIcon from "@/assets/icons/misc/new-plus-icon.tsx"
import { cn } from "@/utils/styles.ts"

interface WidgetHeaderProps {
  title: string
  navigateTo?: string
  addItemGoTo?: () => void
  icon?: React.ReactNode
  className?: string
}

const WidgetHeader: React.FC<WidgetHeaderProps> = ({
  title,
  navigateTo,
  addItemGoTo,
  icon,
  className,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const onClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!navigateTo) {
      event.preventDefault()
    } else {
      navigate(navigateTo)
    }
  }

  return (
    <div className="flex justify-between gap-2">
      <div
        className={cn(
          "flex w-[calc(100%-70px)] cursor-pointer items-center gap-2",
          className,
        )}
        onClick={onClick}
      >
        <p className="font-montserrat truncate text-[20px] font-semibold text-[var(--color-neutral-700,#414141)]">
          {t(title)}
        </p>
        {navigateTo && (
          <ArrowRight
            className={"h-3.5 w-2.5"}
            stroke={"var(--color-neutral-400)"}
          />
        )}
      </div>
      {addItemGoTo && (
        <button onClick={addItemGoTo}>{icon ? icon : <NewPlusIcon />}</button>
      )}
    </div>
  )
}

export default WidgetHeader
